import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { useChatCreateUserMutation, useChatDeleteMessageMutation, useChatEventGAPush, useChatGetAgreementQuery, useChatGetRoomTokenLazyQuery, useChatGetUserTokenLazyQuery, useChatPostMessageMutation, useChatSetAgreementMutation, useModal, useNotification } from "@/hooks";
import config from "@/lib/config";
import dayjs from "@/lib/day";
import Styles from "@/styles/Chat.module.scss";
import i18n from "@emoji-mart/data/i18n/ja.json";
import Picker from "@emoji-mart/react";
import classnames from "classnames";
import takeRight from "lodash/takeRight";
import { useCallback, useEffect, useRef, useState, useMemo } from "react";
var ChatPostIcon = function ChatPostIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M19.1599 10.6573L7.3181 4.24478C6.92777 4.04722 6.4887 3.9666 6.05366 4.01259C5.61861 4.05858 5.2061 4.22922 4.86571 4.50402C4.52381 4.77245 4.26643 5.13365 4.12434 5.54445C3.98225 5.95526 3.96146 6.39829 4.06444 6.8206L5.20704 12L4.06565 17.177C3.98599 17.5128 3.98314 17.8623 4.05734 18.1994C4.13153 18.5365 4.28085 18.8525 4.49415 19.1239C4.70746 19.3952 4.97926 19.6149 5.28929 19.7666C5.59933 19.9183 5.9396 19.9981 6.28475 20C6.6519 19.9984 7.0136 19.9111 7.34103 19.745L19.14 13.3557C19.3898 13.2307 19.6001 13.039 19.7478 12.802C19.8955 12.5649 19.9747 12.2916 19.9768 12.0123C19.9789 11.733 19.9037 11.4586 19.7595 11.2193C19.6153 10.9801 19.4078 10.7854 19.1599 10.6567V10.6573ZM18.4568 12.045L6.65958 18.434C6.52103 18.5034 6.36551 18.5318 6.21136 18.5158C6.05721 18.4998 5.91084 18.4401 5.7895 18.3437C5.66816 18.2473 5.57691 18.1182 5.52649 17.9716C5.47607 17.8251 5.46858 17.6672 5.50491 17.5165L5.50883 17.5017L6.55456 12.7521C6.55938 12.7521 6.56391 12.7521 6.56874 12.7521H13.2288C13.4249 12.7521 13.6129 12.6742 13.7516 12.5355C13.8903 12.3969 13.9682 12.2088 13.9682 12.0127C13.9682 11.8166 13.8903 11.6285 13.7516 11.4899C13.6129 11.3512 13.4249 11.2733 13.2288 11.2733H6.56874H6.56089L5.50461 6.48681C5.46572 6.3364 5.47182 6.17788 5.52213 6.0309C5.57245 5.88391 5.66478 5.75492 5.78769 5.65989C5.93158 5.54262 6.1112 5.47799 6.29682 5.4767C6.41454 5.47659 6.53068 5.50386 6.63604 5.55638L18.4785 11.9674C18.4851 11.9697 18.4906 11.9742 18.4943 11.9802C18.4979 11.9861 18.4994 11.9931 18.4984 12C18.4984 12.0223 18.4897 12.0269 18.4571 12.0435"
    })
  }));
};
ChatPostIcon.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var ChatNewMessageIcon = function ChatNewMessageIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("rect", {
      width: "97",
      height: "30",
      rx: "15",
      fill: "#7B7B42"
    }), /*#__PURE__*/_jsx("path", {
      d: "M34.17 13.48H37.89V14.18H34.17V13.48ZM28.91 11.15H33.32V11.79H28.91V11.15ZM28.8 15.12H33.37V15.77H28.8V15.12ZM28.77 13.44H33.44V14.08H28.77V13.44ZM36.03 13.76H36.76V19.25H36.03V13.76ZM30.76 10.14H31.49V11.48H30.76V10.14ZM30.76 13.96H31.49V19.29H30.76V13.96ZM33.81 10.92L34.73 11.2C34.72 11.28 34.66 11.32 34.52 11.34V14.43C34.52 15.93 34.34 17.96 32.93 19.35C32.84 19.18 32.57 18.93 32.39 18.83C33.67 17.57 33.81 15.84 33.81 14.42V10.92ZM37.16 10.22L37.76 10.77C36.82 11.19 35.42 11.53 34.22 11.74C34.18 11.58 34.08 11.32 33.99 11.17C35.11 10.93 36.43 10.58 37.16 10.22ZM31.42 15.96C31.74 16.18 32.83 17.07 33.08 17.3L32.64 17.86C32.32 17.49 31.38 16.61 31.01 16.3L31.42 15.96ZM29.51 11.97L30.1 11.84C30.31 12.28 30.48 12.87 30.53 13.25L29.9 13.42C29.87 13.03 29.71 12.43 29.51 11.97ZM32.07 11.82L32.75 11.97C32.56 12.47 32.35 13.03 32.17 13.4L31.57 13.26C31.75 12.86 31.96 12.24 32.07 11.82ZM30.77 15.45L31.31 15.66C30.8 16.77 29.88 17.95 29.08 18.57C28.96 18.4 28.74 18.16 28.57 18.04C29.38 17.51 30.29 16.43 30.77 15.45ZM39.5 11.18H47.28V11.8H39.5V11.18ZM39.94 12.49H46.82V13.07H39.94V12.49ZM41.46 16.16H46.33V16.64H41.46V16.16ZM41.46 17.25H46.33V17.73H41.46V17.25ZM41.45 18.35H46.39V18.92H41.45V18.35ZM39.03 13.77H47.71V14.39H39.03V13.77ZM42.98 11.6H43.75V14.26H42.98V11.6ZM40.75 10.33L41.41 10.1C41.71 10.41 42.01 10.83 42.14 11.14L41.46 11.41C41.33 11.11 41.03 10.66 40.75 10.33ZM45.25 10.08L46.04 10.32C45.75 10.71 45.43 11.1 45.18 11.37L44.56 11.14C44.79 10.85 45.09 10.39 45.25 10.08ZM41.27 14.04L42.01 14.22C41.42 15.82 40.43 17.18 39.28 18.06C39.16 17.91 38.87 17.63 38.71 17.51C39.85 16.72 40.77 15.48 41.27 14.04ZM41.06 14.99H46.78V19.27H46.01V15.56H41.81V19.29H41.06V14.99ZM50.17 11.65C50.51 11.68 50.94 11.71 51.27 11.71H56.19C56.44 11.71 56.73 11.7 56.93 11.69C56.92 11.91 56.91 12.23 56.91 12.46V17.63C56.91 17.99 56.94 18.44 56.95 18.59H56.05C56.05 18.44 56.07 18.07 56.07 17.71V12.5H51.27C50.9 12.5 50.41 12.52 50.17 12.54V11.65ZM50.05 17.17C50.3 17.19 50.74 17.22 51.15 17.22H56.52V18.04H51.18C50.77 18.04 50.32 18.05 50.05 18.08V17.17ZM66.63 11.22C66.53 11.41 66.39 11.75 66.31 11.96C65.93 12.95 65.33 14.25 64.51 15.29C63.55 16.51 62.25 17.83 60.36 18.81L59.68 18.19C61.54 17.3 62.82 16.11 63.85 14.8C64.67 13.74 65.17 12.63 65.51 11.65C65.58 11.45 65.67 11.12 65.72 10.91L66.63 11.22ZM61.35 12.4C62.34 13.03 63.73 14.03 64.49 14.64C65.49 15.46 66.48 16.33 67.27 17.19L66.64 17.88C65.81 16.92 64.94 16.13 63.94 15.29C63.22 14.69 61.92 13.7 60.82 13.03L61.35 12.4ZM70.89 11.18C71.59 11.65 72.88 12.69 73.43 13.24L72.81 13.88C72.3 13.36 71.06 12.28 70.31 11.79L70.89 11.18ZM70.03 17.88C71.77 17.62 73.07 17.01 74.02 16.42C75.57 15.45 76.78 13.97 77.36 12.73L77.84 13.59C77.16 14.83 76 16.19 74.49 17.14C73.48 17.77 72.22 18.39 70.55 18.7L70.03 17.88ZM82.06 17.62C82.06 17.06 82.06 12.64 82.06 11.81C82.06 11.52 82.04 11.08 81.99 10.76H82.97C82.93 11.07 82.9 11.5 82.9 11.81C82.9 13.36 82.91 17.15 82.91 17.62C82.91 17.94 82.93 18.48 82.97 18.81H82C82.05 18.49 82.06 17.99 82.06 17.62ZM82.72 13.39C84.04 13.77 86.06 14.54 87.17 15.08L86.82 15.93C85.68 15.32 83.81 14.61 82.72 14.27V13.39Z",
      fill: "#FAFAFA"
    }), /*#__PURE__*/_jsx("path", {
      d: "M17.75 9C17.75 8.58579 17.4142 8.25 17 8.25C16.5858 8.25 16.25 8.58579 16.25 9H17.75ZM16.4697 20.5303C16.7626 20.8232 17.2374 20.8232 17.5303 20.5303L22.3033 15.7574C22.5962 15.4645 22.5962 14.9896 22.3033 14.6967C22.0104 14.4038 21.5355 14.4038 21.2426 14.6967L17 18.9393L12.7574 14.6967C12.4645 14.4038 11.9896 14.4038 11.6967 14.6967C11.4038 14.9896 11.4038 15.4645 11.6967 15.7574L16.4697 20.5303ZM16.25 9V20H17.75V9H16.25Z",
      fill: "white"
    })]
  }));
};
ChatNewMessageIcon.defaultProps = {
  width: "97",
  height: "30",
  viewBox: "0 0 97 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var EmojiIcon = function EmojiIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M9.375 11.625C9.67337 11.625 9.95952 11.5065 10.1705 11.2955C10.3815 11.0845 10.5 10.7984 10.5 10.5C10.5 10.2016 10.3815 9.91548 10.1705 9.7045C9.95952 9.49353 9.67337 9.375 9.375 9.375C9.07663 9.375 8.79048 9.49353 8.5795 9.7045C8.36853 9.91548 8.25 10.2016 8.25 10.5C8.25 10.7984 8.36853 11.0845 8.5795 11.2955C8.79048 11.5065 9.07663 11.625 9.375 11.625ZM9.204 14.5005C9.1386 14.4261 9.0591 14.3653 8.9701 14.3218C8.8811 14.2783 8.78435 14.2528 8.68545 14.2469C8.58655 14.241 8.48746 14.2547 8.3939 14.2873C8.30033 14.3199 8.21415 14.3707 8.14034 14.4368C8.06652 14.5029 8.00653 14.5829 7.96384 14.6723C7.92114 14.7617 7.89657 14.8587 7.89157 14.9577C7.88656 15.0566 7.90121 15.1556 7.93467 15.2488C7.96813 15.3421 8.01973 15.4278 8.0865 15.501C8.57907 16.0514 9.18225 16.4917 9.85662 16.7931C10.531 17.0945 11.2614 17.2502 12 17.25C12.7386 17.2502 13.469 17.0945 14.1434 16.7931C14.8177 16.4917 15.4209 16.0514 15.9135 15.501C16.044 15.3525 16.1106 15.1584 16.0988 14.9611C16.0869 14.7637 15.9977 14.579 15.8504 14.4472C15.7031 14.3153 15.5097 14.2469 15.3122 14.2569C15.1148 14.2669 14.9292 14.3544 14.796 14.5005C14.4441 14.8938 14.0132 15.2084 13.5314 15.4237C13.0496 15.639 12.5277 15.7502 12 15.75C10.89 15.75 9.8925 15.2685 9.204 14.5005ZM15.75 10.5C15.75 10.7984 15.6315 11.0845 15.4205 11.2955C15.2095 11.5065 14.9234 11.625 14.625 11.625C14.3266 11.625 14.0405 11.5065 13.8295 11.2955C13.6185 11.0845 13.5 10.7984 13.5 10.5C13.5 10.2016 13.6185 9.91548 13.8295 9.7045C14.0405 9.49353 14.3266 9.375 14.625 9.375C14.9234 9.375 15.2095 9.49353 15.4205 9.7045C15.6315 9.91548 15.75 10.2016 15.75 10.5ZM21 12C21 10.8181 20.7672 9.64778 20.3149 8.55585C19.8626 7.46392 19.1997 6.47177 18.364 5.63604C17.5282 4.80031 16.5361 4.13738 15.4442 3.68508C14.3522 3.23279 13.1819 3 12 3C10.8181 3 9.64778 3.23279 8.55585 3.68508C7.46392 4.13738 6.47177 4.80031 5.63604 5.63604C4.80031 6.47177 4.13738 7.46392 3.68508 8.55585C3.23279 9.64778 3 10.8181 3 12C3 14.3869 3.94821 16.6761 5.63604 18.364C7.32387 20.0518 9.61305 21 12 21C14.3869 21 16.6761 20.0518 18.364 18.364C20.0518 16.6761 21 14.3869 21 12ZM4.5 12C4.5 10.0109 5.29018 8.10322 6.6967 6.6967C8.10322 5.29018 10.0109 4.5 12 4.5C13.9891 4.5 15.8968 5.29018 17.3033 6.6967C18.7098 8.10322 19.5 10.0109 19.5 12C19.5 13.9891 18.7098 15.8968 17.3033 17.3033C15.8968 18.7098 13.9891 19.5 12 19.5C10.0109 19.5 8.10322 18.7098 6.6967 17.3033C5.29018 15.8968 4.5 13.9891 4.5 12Z"
    })
  }));
};
EmojiIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import { Button } from "../Buttons";
import ChatMessageDeleteModal from "./ChatMessageDeleteModal";
import ChatMessageReportModal from "./ChatMessageReportModal";
import GuidelineAgreementModal from "./GuidelineAgreementModal";
import NickNameInputModal from "./NickNameInputModal";
import split from "graphemesplit";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
i18n.search_no_results_1 = "該当なし";
const watchPartyOptions = {
  endpoint: config.chat.endpoint,
  types: ["message", "messageUpdated", "error"]
};
const chatEndTimeBefore = 15;
const checkChatEndTime = 30000;
const chatMessageLimit = 200;
const ChatDisplay = _ref => {
  var _rooms$chatRoomIndex$, _rooms$chatRoomIndex, _rooms$chatRoomIndex$2, _rooms$chatRoomIndex2, _rooms$chatRoomIndex$3, _rooms$chatRoomIndex3, _rooms$chatRoomIndex5, _rooms$chatRoomIndex8;
  let {
    rooms,
    chatDisplay,
    setChatDisplay,
    setChatEnable,
    metaId,
    encodeEndDate,
    user
  } = _ref;
  const {
    showModal,
    hideModal
  } = useModal();
  const {
    0: guidelineAgreement,
    1: setGuidelineAgreement
  } = useState(false);
  const {
    0: nickName,
    1: setNickName
  } = useState("");
  const {
    0: chatMessageInput,
    1: setChatMessageInput
  } = useState("");
  const {
    0: chatMessages,
    1: setChatMessages
  } = useState([]);
  const chatRoomInfoDefault = {
    id: null,
    token: null,
    liveEndAfter: null,
    chatEndDateTime: null
  };
  const {
    0: chatRoomInfo,
    1: setChatRoomInfo
  } = useState(chatRoomInfoDefault);
  const chatUserInfoDefault = {
    id: null,
    refId: null,
    roomId: null,
    token: null
  };
  const {
    0: chatUserInfo,
    1: setChatUserInfo
  } = useState(chatUserInfoDefault);
  const {
    0: loaded,
    1: setLoaded
  } = useState(false);
  const {
    0: isViewingPastMessage,
    1: setIsViewingPastMessage
  } = useState(false);
  const {
    0: isMessageControlling,
    1: setIsMessageControlling
  } = useState(false);
  const {
    0: mutedMessages,
    1: setMutedMessages
  } = useState([]);
  const {
    0: mutedUsers,
    1: setMutedUsers
  } = useState([]);
  const {
    0: displayChatEndNotification,
    1: setDisplayChatEndNotification
  } = useState("none");
  const {
    0: displayEmojiPicker,
    1: setDisplayEmojiPicker
  } = useState(false);
  const {
    0: isComposing,
    1: setIsComposing
  } = useState(false);
  const {
    0: isChatError,
    1: setIsChatError
  } = useState(false);
  const {
    0: isPostedNGMessage,
    1: setIsPostedNGMessage
  } = useState(false);
  const {
    0: chatRoomIndex,
    1: setChatRoomIndex
  } = useState(0);
  const {
    0: reportedMessageIds,
    1: setReportedMessageIds
  } = useState([]);
  const appMessageLimit = (_rooms$chatRoomIndex$ = rooms === null || rooms === void 0 || (_rooms$chatRoomIndex = rooms[chatRoomIndex]) === null || _rooms$chatRoomIndex === void 0 || (_rooms$chatRoomIndex = _rooms$chatRoomIndex.customData) === null || _rooms$chatRoomIndex === void 0 ? void 0 : _rooms$chatRoomIndex.appMessageLimit) !== null && _rooms$chatRoomIndex$ !== void 0 ? _rooms$chatRoomIndex$ : 100;
  const roomUpdateMessageLimit = (_rooms$chatRoomIndex$2 = rooms === null || rooms === void 0 || (_rooms$chatRoomIndex2 = rooms[chatRoomIndex]) === null || _rooms$chatRoomIndex2 === void 0 || (_rooms$chatRoomIndex2 = _rooms$chatRoomIndex2.config) === null || _rooms$chatRoomIndex2 === void 0 ? void 0 : _rooms$chatRoomIndex2.messageLimit) !== null && _rooms$chatRoomIndex$2 !== void 0 ? _rooms$chatRoomIndex$2 : 100;
  const {
    0: chatMessagePushStack,
    1: setChatMessagePushStack
  } = useState([]);
  const {
    0: chatMessagePopStack,
    1: setChatMessagePopStack
  } = useState([]);
  const chatIntervalMax = 500;
  const chatIntervalMin = 4;
  const chatIntervalIdol = (_rooms$chatRoomIndex$3 = rooms === null || rooms === void 0 || (_rooms$chatRoomIndex3 = rooms[chatRoomIndex]) === null || _rooms$chatRoomIndex3 === void 0 || (_rooms$chatRoomIndex3 = _rooms$chatRoomIndex3.config) === null || _rooms$chatRoomIndex3 === void 0 ? void 0 : _rooms$chatRoomIndex3.pollingnterval) !== null && _rooms$chatRoomIndex$3 !== void 0 ? _rooms$chatRoomIndex$3 : 5000;
  const {
    0: chatInterval,
    1: setChatInterval
  } = useState(chatIntervalIdol);
  const {
    0: chatIntervalStandard,
    1: setChatIntervalStandard
  } = useState(chatIntervalIdol);
  const watchPartyRef = useRef(null);
  const chatMessageAreaRef = useRef(null);
  const chatInputRef = useRef(null);
  const intervalId = useRef(null);
  const {
    0: chatEndTime,
    1: setChatEndTime
  } = useState(null);
  const messageSending = useRef(false);
  const messagesUpdating = useRef(false);
  const messageUpdatingTimeout = useRef(null);
  const {
    0: isWarningVisible,
    1: setIsWarningVisible
  } = useState(true);
  const {
    0: chatJoined,
    1: setChatJoined
  } = useState(false);
  const roomUpdateIntervalId = useRef(null);
  const roomUpdateIntervalMinute = 5 * 60 * 1000;
  const {
    0: lastRoomUpdatedCheckTimeStamp,
    1: setLastRoomUpdatedCheckTimeStamp
  } = useState(new Date().getTime());
  const count = useMemo(() => {
    return split(chatMessageInput === null || chatMessageInput === void 0 ? void 0 : chatMessageInput.trim()).length;
  }, [chatMessageInput]);
  const isChatSendOK = useMemo(() => {
    var _chatMessageInput$tri;
    return count > 0 && count <= chatMessageLimit && (chatMessageInput === null || chatMessageInput === void 0 || (_chatMessageInput$tri = chatMessageInput.trim()) === null || _chatMessageInput$tri === void 0 ? void 0 : _chatMessageInput$tri.length) != 0;
  }, [count, chatMessageInput]);
  const isChatInputOver = useMemo(() => {
    return count > chatMessageLimit;
  }, [count]);
  const {
    guideLineAgreementEvent,
    sendCommentEvent,
    reportCommentEvent
  } = useChatEventGAPush();
  const hideChat = useCallback(() => {
    setChatDisplay(false);
  }, [setChatDisplay]);
  const turnOnIsComposing = useCallback(() => {
    setIsComposing(true);
  }, []);
  const turnOffIsComposing = useCallback(() => {
    setIsComposing(false);
  }, []);

  // チャット送信制御自体はmessageSendingで行うが、input要素の無効/有効切替後にフォーカスかけたいのでレンダリング用のstateを設ける
  const {
    0: isMessageInputOK,
    1: setIsMessageInputOK
  } = useState(true);
  //主に未ログインなどでGraphQLがエラーのときチャットコンポーネント破棄する。課題：一瞬見えることがある
  const agreementOnError = useCallback(() => {
    hideChat();
    setChatEnable(false);
  }, [hideChat, setChatEnable]);
  const {
    loading: agreementDataLoading
  } = useChatGetAgreementQuery({
    onCompleted: _ref2 => {
      let {
        getChatGuideLineAgreement
      } = _ref2;
      setGuidelineAgreement(getChatGuideLineAgreement === null || getChatGuideLineAgreement === void 0 ? void 0 : getChatGuideLineAgreement.agreement);
    },
    onError: agreementOnError
  });
  const [setAgreementMutation] = useChatSetAgreementMutation({
    onCompleted: _ref3 => {
      var _rooms$chatRoomIndex4;
      let {
        setChatGuideLineAgreement
      } = _ref3;
      setGuidelineAgreement(setChatGuideLineAgreement === null || setChatGuideLineAgreement === void 0 ? void 0 : setChatGuideLineAgreement.agreement);
      guideLineAgreementEvent(rooms === null || rooms === void 0 || (_rooms$chatRoomIndex4 = rooms[chatRoomIndex]) === null || _rooms$chatRoomIndex4 === void 0 ? void 0 : _rooms$chatRoomIndex4.roomId);
    }
  });
  const [getRoomTokenQuery] = useChatGetRoomTokenLazyQuery({
    variables: {
      roomId: rooms === null || rooms === void 0 || (_rooms$chatRoomIndex5 = rooms[chatRoomIndex]) === null || _rooms$chatRoomIndex5 === void 0 ? void 0 : _rooms$chatRoomIndex5.roomId
    },
    onCompleted: _ref4 => {
      let {
        getRoomToken
      } = _ref4;
      if (getRoomToken == null) {
        setIsChatError(true);
      } else {
        var _rooms$chatRoomIndex6, _rooms$chatRoomIndex7;
        setChatRoomInfo({
          id: rooms === null || rooms === void 0 ? void 0 : rooms[chatRoomIndex].roomId,
          token: getRoomToken.token,
          liveEndAfter: rooms === null || rooms === void 0 || (_rooms$chatRoomIndex6 = rooms[chatRoomIndex]) === null || _rooms$chatRoomIndex6 === void 0 || (_rooms$chatRoomIndex6 = _rooms$chatRoomIndex6.customData) === null || _rooms$chatRoomIndex6 === void 0 ? void 0 : _rooms$chatRoomIndex6.liveEndAfter,
          chatEndDateTime: rooms === null || rooms === void 0 || (_rooms$chatRoomIndex7 = rooms[chatRoomIndex]) === null || _rooms$chatRoomIndex7 === void 0 || (_rooms$chatRoomIndex7 = _rooms$chatRoomIndex7.customData) === null || _rooms$chatRoomIndex7 === void 0 ? void 0 : _rooms$chatRoomIndex7.chatEndDateTime
        });
      }
    },
    onError: e => {
      console.log("error on getRoomToken:", e);
      setIsChatError(true);
    }
  });
  const [createUserMutation] = useChatCreateUserMutation({
    variables: {
      roomId: rooms === null || rooms === void 0 || (_rooms$chatRoomIndex8 = rooms[chatRoomIndex]) === null || _rooms$chatRoomIndex8 === void 0 ? void 0 : _rooms$chatRoomIndex8.roomId,
      metaId: Number(metaId)
    },
    onCompleted: _ref5 => {
      let {
        createUser
      } = _ref5;
      if (createUser == null) {
        setIsChatError(true);
      } else {
        setChatUserInfo(_objectSpread(_objectSpread({}, chatUserInfo), {}, {
          id: createUser.id,
          refId: createUser.refId,
          roomId: createUser.roomId
        }));
      }
    },
    onError: e => {
      var _e$graphQLErrors;
      console.log("error on CreateUser:", e);
      const errorCode = e === null || e === void 0 || (_e$graphQLErrors = e.graphQLErrors) === null || _e$graphQLErrors === void 0 || (_e$graphQLErrors = _e$graphQLErrors[0]) === null || _e$graphQLErrors === void 0 || (_e$graphQLErrors = _e$graphQLErrors.extensions) === null || _e$graphQLErrors === void 0 || (_e$graphQLErrors = _e$graphQLErrors.error) === null || _e$graphQLErrors === void 0 ? void 0 : _e$graphQLErrors.code;
      setChatUserInfo(chatUserInfoDefault);
      // errorがユーザー上限だった場合roomIndexを次のものにして取得を試みる
      if (errorCode == 91009) {
        setChatRoomIndex(chatRoomIndex + 1);
      } else {
        setIsChatError(true);
      }
    }
  });
  const [getUserTokenQuery] = useChatGetUserTokenLazyQuery({
    variables: {
      roomId: chatRoomInfo.id,
      userId: chatUserInfo.id
    },
    onCompleted: _ref6 => {
      let {
        getUserToken
      } = _ref6;
      if (getUserToken == null) {
        setIsChatError(true);
      } else {
        setChatUserInfo(_objectSpread(_objectSpread({}, chatUserInfo), {}, {
          token: getUserToken.token
        }));
        setLoaded(true);
      }
    },
    onError: e => {
      console.log("error on getUserToken:", e);
      setIsChatError(true);
    }
  });
  const [chatDeleteMessageMutation] = useChatDeleteMessageMutation({
    variables: {
      roomId: chatRoomInfo.id
    }
  });
  const {
    showNotification
  } = useNotification();
  const [chatPostMessageMutation] = useChatPostMessageMutation({
    variables: {
      roomId: chatRoomInfo.id,
      userId: chatUserInfo.id,
      refId: chatUserInfo.refId,
      displayName: nickName,
      token: chatUserInfo.token
    }
  });

  // ガイドライン同意ダイアログに渡すハンドル
  const handleAgreementClick = useCallback(() => {
    // ガイドライン同意cookie設定
    setAgreementMutation({});
    hideModal();
  }, []);

  // ニックネーム入力ダイアログに渡すハンドル
  const handleNickNameDecisionClick = useCallback(data => {
    if (!data.nickName || data.nickName == "" || data.nickName.trim() == "") {
      return;
    }
    setNickName(data.nickName.trim());
    hideModal();
  }, []);

  // チャットメッセージ入力に渡すハンドル
  const handleChatMessageInputChange = useCallback(e => {
    setChatMessageInput(e.target.value);
  }, []);
  const handleChatMessageOnKeyDown = useCallback(e => {
    // keyCodeは非推奨だが、safariのみcompositionEndとkeyDownの発火順が異なるためkey=="Enter"では判別不可。
    // safariは変換確定(229)とその他のEnter(13)でkeyCodeが異なるため判別可能
    if (e.keyCode === 13 && !isComposing && !messageSending.current && isChatSendOK) {
      setIsMessageInputOK(false);
      handlePost();
    }
  }, [isComposing, chatMessageInput, isChatSendOK]);

  // チャットメッセージ表示エリアのスクロール時の処理
  const handleChatMessageAreaScroll = useCallback(e => {
    if (
    //メッセージ更新中は動作させない（チャット量が多い時にチラつくのを防止）
    !messagesUpdating.current &&
    // ジャンプボタン表示にメッセージ要素の高さ×2くらいのマージン持つ
    e.target.scrollTop + e.target.offsetHeight < e.target.scrollHeight - 32) {
      if (!isViewingPastMessage) {
        setIsViewingPastMessage(true);
        setIsWarningVisible(false);
        watchPartyRef.current.pause();
      }
    } else {
      if (isViewingPastMessage) {
        setIsViewingPastMessage(false);
        setIsWarningVisible(true);
        watchPartyRef.current.start();
      }
    }
  }, [isViewingPastMessage]);

  // チャットメッセージ押下時の処理
  const handleChatMessageClick = useCallback(e => {
    const messageData = chatMessages.filter(message => {
      return message.id == e.currentTarget.dataset.id;
    });
    const {
      id,
      displayName,
      postDesc,
      userId
    } = messageData[0];
    if (userId == chatUserInfo.id) {
      displayChatMessageDeleteModal(messageData[0]);
    } else {
      displayChatMessageReportModal(messageData[0]);
    }
  }, [chatMessages, chatUserInfo, reportedMessageIds]);

  // メッセージ削除ダイアログに渡すハンドル
  const handleChatMessageDeleteClick = useCallback(id => {
    chatDeleteMessageMutation({
      variables: {
        messageId: id
      },
      onError: e => {
        console.log("error on deleteMessage:", e);
      }
    });
    hideModal();
    watchPartyRef.current.start();
    addMutedMessage(id);
    setIsMessageControlling(false);
  }, []);
  const addMutedMessage = useCallback(id => {
    setMutedMessages(mutedMessages => [...mutedMessages, id]);
    unsetMessage(id);
  }, []);
  const addMutedUser = useCallback(userId => {
    setMutedUsers(mutedUsers => [...mutedUsers, userId]);
    unsetUserMessages(userId);
  }, []);
  const reportComplete = useCallback(() => {
    showNotification("ご報告いただきありがとうございます。このチャットがガイドラインに違反している場合、速やかに対処いたします。", {
      time: 3000
    });
    hideModal();
    watchPartyRef.current.start();
    setIsMessageControlling(false);
  }, []);

  // 通報済みメッセージIDリスト
  const handleReportComplete = useCallback(messageId => {
    setReportedMessageIds(prevIds => [...prevIds, messageId]);
    reportCommentEvent();
  }, []);

  // ガイドライン同意しない場合チャットコンポーネントも閉じる
  const modalAndComponentCloseHandle = useCallback(() => {
    hideModal();
    hideChat();
  }, [hideModal, hideChat]);

  // ガイドライン同意ダイアログ表示
  const displayAgreementModal = useCallback(() => {
    showModal( /*#__PURE__*/_jsx(GuidelineAgreementModal, {
      handleClick: handleAgreementClick,
      modalAndComponentCloseHandle: modalAndComponentCloseHandle // モーダルコンポーネントの閉じるボタンを利用しないので、別途CLOSEボタン用の関数を渡す
    }), {
      closeButton: false,
      outerAreaClose: false,
      style: "guidelineAgreementModal",
      onClose: hideChat
    });
  }, [showModal, handleAgreementClick, modalAndComponentCloseHandle, hideChat]);

  // ニックネーム入力ダイアログ表示
  const displayNickNameInputModal = useCallback(() => {
    if (!nickName) {
      showModal( /*#__PURE__*/_jsx(NickNameInputModal, {
        handleClick: handleNickNameDecisionClick,
        modalCloseHandle: hideModal // モーダルコンポーネントの閉じるボタンを利用しないので、別途CLOSEボタン用の関数を渡す
      }), {
        closeButton: false,
        outerAreaClose: false,
        style: "nickNameInputModal"
      });
    }
  }, [showModal, hideModal, handleNickNameDecisionClick, nickName]);

  // 最新までスクロール処理
  const scrollToRecent = useCallback(() => {
    var _chatMessageAreaRef$c;
    if (chatMessageAreaRef !== null && chatMessageAreaRef !== void 0 && (_chatMessageAreaRef$c = chatMessageAreaRef.current) !== null && _chatMessageAreaRef$c !== void 0 && _chatMessageAreaRef$c.scrollHeight) {
      var _chatMessageAreaRef$c2;
      chatMessageAreaRef.current.scrollTo({
        top: (_chatMessageAreaRef$c2 = chatMessageAreaRef.current) === null || _chatMessageAreaRef$c2 === void 0 ? void 0 : _chatMessageAreaRef$c2.scrollHeight
      });
    }
  }, [chatMessageAreaRef]);

  // ジャンプボタンの処理
  const jumpButtonClickHandler = useCallback(() => {
    var _watchPartyRef$curren;
    //慣性スクロールを止める
    chatMessageAreaRef.current.style.overflowY = "hidden";
    scrollToRecent(); // scrollに戻す前にスクロールさせる必要がある
    chatMessageAreaRef.current.style.overflowY = "scroll";
    //hiddenからscrollに戻した際、スクロールバーの有無で改行が発生してずれている分をジャンプするためもう一度実行する
    scrollToRecent();
    setIsViewingPastMessage(false);
    setIsWarningVisible(true);
    watchPartyRef === null || watchPartyRef === void 0 || (_watchPartyRef$curren = watchPartyRef.current) === null || _watchPartyRef$curren === void 0 || _watchPartyRef$curren.start();
  }, [scrollToRecent]);

  // チャットコンポーネント呼び出し時にガイドライン同意ダイアログを表示する
  useEffect(() => {
    if (loaded && !guidelineAgreement && chatDisplay) {
      displayAgreementModal();
    }
  }, [loaded, guidelineAgreement, chatDisplay]);

  // メタから取得したroomから入室するroomを選択する
  useEffect(() => {
    if (chatRoomIndex >= (rooms === null || rooms === void 0 ? void 0 : rooms.length)) {
      console.log("全てのルームが満室です");
      setIsChatError(true);
    } else {
      getRoomTokenQuery();
    }
  }, [chatRoomIndex]);

  // ルームトークンが取得できたらユーザー作成を行う
  useEffect(() => {
    if (chatRoomInfo.token && !chatUserInfo.id) {
      createUserMutation();
    }
  }, [chatRoomInfo]);

  // ユーザー作成ができたらユーザートークンを取得する
  useEffect(() => {
    if (chatUserInfo.id && !chatUserInfo.token) {
      getUserTokenQuery();
    }
  }, [chatUserInfo]);

  // ユーザートークンを取得できたらWatchPartyクライアントを初期化して、ルームに入室する
  useEffect(() => {
    // 引数
    // roomToken
    // project
    // ユーザーID
    // option
    if (chatRoomInfo.token && chatUserInfo.id && chatUserInfo.token && guidelineAgreement) {
      watchPartyRef.current = new WatchPartyClient(chatRoomInfo.token, config.chat.projectId, chatRoomInfo.id, watchPartyOptions);

      // 作成済みユーザー数取得できる
      // const wpRoomInfo = watchPartyRef.current._getRoomInfo(
      //   config.chat.projectId,
      //   chatRoomInfo.id,
      //   (dummy, info) => {
      //     setChatRoomInfo({
      //       ...chatRoomInfo,
      //       userCount: info.userCount,
      //     });
      //   }
      // );

      watchPartyRef.current.on("message", handleMessage);
      watchPartyRef.current.on("messageUpdated", handleMessageUpdated);
      watchPartyRef.current.on("error", handleMessageError);
      handleJoin();
    }
    return () => {
      if (watchPartyRef.current) {
        watchPartyDispose();
      }
    };
  }, [chatRoomInfo.token, chatRoomInfo.id, chatUserInfo, watchPartyOptions, guidelineAgreement]);

  // チャット表示時最新までスクロールする
  useEffect(() => {
    // 新しいメッセージを取得したとき、過去メッセージ表示またはメッセージの削除や通報操作中でなければ最新までスクロールする
    if (!isViewingPastMessage && !isMessageControlling) {
      scrollToRecent();
    }
  }, [chatDisplay, chatMessages, scrollToRecent]);
  useEffect(() => {
    if (isMessageInputOK) {
      var _chatInputRef$current;
      chatInputRef === null || chatInputRef === void 0 || (_chatInputRef$current = chatInputRef.current) === null || _chatInputRef$current === void 0 || _chatInputRef$current.focus();
    } else {
      var _chatInputRef$current2;
      chatInputRef === null || chatInputRef === void 0 || (_chatInputRef$current2 = chatInputRef.current) === null || _chatInputRef$current2 === void 0 || _chatInputRef$current2.blur();
    }
  }, [isMessageInputOK]);

  // チャット終了の告知・終了をチェックする処理
  const chatAnnounce = useCallback(() => {
    const now = dayjs();
    const tmpChatEndTime = chatRoomInfo !== null && chatRoomInfo !== void 0 && chatRoomInfo.chatEndDateTime ? dayjs(chatRoomInfo.chatEndDateTime) : dayjs(encodeEndDate).add(chatRoomInfo.liveEndAfter || 0, "minute");
    const chatEndAnnounceTime = tmpChatEndTime.subtract(chatEndTimeBefore, "minute");
    if (chatEndAnnounceTime.isBefore(now) && tmpChatEndTime.isAfter(now)) {
      // チャット終了告知時間より後、かつチャット終了時間より前
      setDisplayChatEndNotification("nearlyEnd");
    } else if (tmpChatEndTime.isBefore(now)) {
      // 現在時刻が終了時間を過ぎている
      setDisplayChatEndNotification("ended");
    } else {
      // 通常時
      setDisplayChatEndNotification("none");
    }
    setChatEndTime(tmpChatEndTime);
  }, [encodeEndDate, chatRoomInfo.chatEndDateTime, chatRoomInfo.liveEndAfter]);
  useEffect(() => {
    if (intervalId.current) {
      clearInterval(intervalId.current);
    }
    chatAnnounce();
    intervalId.current = setInterval(chatAnnounce, checkChatEndTime);
    return () => {
      if (intervalId.current) {
        clearInterval(intervalId.current);
        intervalId.current = null;
      }
    };
  }, [encodeEndDate, chatAnnounce]);

  // 非表示時にポーリング停止する、表示時に再開する
  useEffect(() => {
    if (!watchPartyRef.current) return;
    if (chatDisplay) {
      watchPartyRef.current.start();
    } else {
      watchPartyRef.current.pause();
    }
  }, [chatDisplay]);

  // 退室とクライアントの破棄
  const watchPartyDispose = useCallback(() => {
    watchPartyRef.current.pause();
    watchPartyRef.current.leave();
    watchPartyRef.current.off("message", handleMessage);
    watchPartyRef.current.off("messageUpdated", handleMessageUpdated);
    watchPartyRef.current.off("error", handleMessageError);
    delete watchPartyRef.current;
  }, []);

  // 入室処理
  const handleJoin = useCallback(() => {
    if (!watchPartyRef.current) return;
    watchPartyRef.current.join(chatUserInfo.id, chatUserInfo.token, (error, body) => {
      var _error$body, _error$body2;
      // roomが404
      console.log("join error:", error);
      console.log("join body:", body);
      if (error && ((_error$body = error.body) === null || _error$body === void 0 ? void 0 : _error$body.statusCode) === 403) {}
      if (error && ((_error$body2 = error.body) === null || _error$body2 === void 0 ? void 0 : _error$body2.statusCode) === 404) {
        // 裏ではjoinできているので不整合が発生する為消しておく
        // TODO: user削除とdisposeを行う
        // this.doDeleteUser(this.user.id);
        if (watchPartyRef.current) {
          watchPartyDispose();
        }
        setIsChatError(true);
      }
      setChatJoined(true);
      // 表示されていたらstart
      if (chatDisplay) watchPartyRef.current.start();
    });
  }, [chatUserInfo, chatDisplay, watchPartyDispose]);

  // チャットメッセージキュー定義
  const setChatIntervalRandom = useCallback(() => {
    if (chatIntervalStandard == chatIntervalIdol) {
      setChatInterval(chatIntervalStandard);
      return;
    }
    // // 0.2 ~ 1.8のランダムをかける、両端に偏った乱数にする（0.2または1.8に近い値が出やすく、中央の1.0は出にくい）
    let baseRandom = (Math.random() + Math.random()) / 2 + 0.5; // 0.5の頻度が高く、0,1に近づくほど頻度の低い乱数を生成し、0.5足す
    if (baseRandom > 1.0) {
      baseRandom = baseRandom - 1.0; // 1.0超えているものを1引くことで、0.5の頻度が低く、0,1に近づくほど頻度の高い乱数になる
    }

    const newChatInterval = chatIntervalStandard * (baseRandom * 1.6 + 0.2);
    setChatInterval(newChatInterval);
  }, [chatIntervalStandard, chatIntervalIdol]);
  const chatMessageEnQueue = useCallback(value => {
    setChatMessagePushStack(chatMessagePushStack => [...chatMessagePushStack, value]);
  }, []);
  const chatMessageDeQueue = useCallback(() => {
    const tempChatMessagePopStack = chatMessagePopStack;
    if (tempChatMessagePopStack.length === 0) {
      const tempChatMessagePushStack = chatMessagePushStack;
      if (tempChatMessagePushStack.length > 0) {
        let newChatInterval;
        if (chatMessages.length == 0) {
          newChatInterval = chatIntervalMin;
        } else {
          newChatInterval = Math.max(chatIntervalMin, Math.min(chatIntervalMax, chatIntervalIdol / tempChatMessagePushStack.length));
        }
        setChatIntervalStandard(newChatInterval);
        while (tempChatMessagePushStack.length > 0) {
          tempChatMessagePopStack.push(tempChatMessagePushStack.pop());
        }
        setChatMessagePushStack([]);
      } else {
        setChatIntervalStandard(chatIntervalIdol);
      }
    }
    const ret = tempChatMessagePopStack === null || tempChatMessagePopStack === void 0 ? void 0 : tempChatMessagePopStack.pop();
    setChatMessagePopStack(tempChatMessagePopStack);
    return ret;
  }, [chatIntervalIdol, chatMessagePopStack, chatMessagePushStack, chatMessages]);
  const chatMessageFilter = useCallback(target => {
    // NGメッセージは表示しない
    if (target.isNGMessage) {
      return false;
    }
    // 非表示にしているユーザーのメッセージは表示しない
    const filterMutedUser = mutedUsers.filter(user => {
      return user == target.sender.id;
    });
    if (filterMutedUser.length > 0) {
      return false;
    }
    // 同じメッセージのイベントを複数受信することがあるので確認
    const filterDuplicate = chatMessages.filter(filtered => {
      return filtered.id == target.id;
    });
    // 同一メッセージだったら表示しない
    if (filterDuplicate.length > 0) {
      return false;
    }
    // ミュート済みのメッセージを受信している場合表示しない
    const filterMutedMessage = mutedMessages.filter(filtered => {
      return filtered == target.id;
    });
    // 同一メッセージだったら表示しない
    if (filterMutedMessage.length > 0) {
      return false;
    }
    return true;
  }, [mutedUsers, mutedMessages, chatMessages]);

  // メッセージ受信イベントに対する処理
  const handleMessage = useCallback(event => {
    if (!chatMessageFilter(event)) return;
    chatMessageEnQueue(event);
    if (chatMessages.length == 0) {
      setChatInterval(chatIntervalMin);
    }
  }, [chatMessages, chatMessageFilter, chatMessageEnQueue]);

  // メッセージ更新イベントの処理
  const handleMessageUpdated = useCallback(event => {
    var _event$message;
    // NGメッセージは表示しない
    if (event !== null && event !== void 0 && (_event$message = event.message) !== null && _event$message !== void 0 && (_event$message = _event$message.data) !== null && _event$message !== void 0 && _event$message.isNGMessage) {
      var _event$message2;
      unsetMessage(event === null || event === void 0 || (_event$message2 = event.message) === null || _event$message2 === void 0 || (_event$message2 = _event$message2.data) === null || _event$message2 === void 0 ? void 0 : _event$message2.id);
    }
  }, []);

  // エラーイベントの処理
  const handleMessageError = useCallback(event => {
    console.log(event);
  }, []);
  const chatMessageModifier = useCallback(update => {
    if (messageUpdatingTimeout.current) clearTimeout(messageUpdatingTimeout.current);
    messagesUpdating.current = true;
    setChatMessages(update);
    messageUpdatingTimeout.current = setTimeout(() => {
      messagesUpdating.current = false;
    }, 50);
  }, []);

  // 指定のメッセージをフロント上で非表示にする
  const unsetMessage = useCallback(id => {
    chatMessageModifier(chatMessages => chatMessages.filter(message => {
      return message.id != id;
    }));
  }, [chatMessageModifier]);

  // 指定のユーザーが投稿したメッセージをフロント上で非表示にする
  const unsetUserMessages = useCallback(userId => {
    chatMessageModifier(chatMessages => chatMessages.filter(message => {
      return message.userId != userId;
    }));
  }, [chatMessageModifier]);

  // チャット投稿処理
  const handlePost = useCallback(() => {
    if (!watchPartyRef.current) {
      setIsMessageInputOK(true);
      return;
    }
    if (!chatMessageInput || chatMessageInput.trim() == "") {
      setChatMessageInput("");
      setIsMessageInputOK(true);
      return;
    }
    setIsPostedNGMessage(false);
    if (messageSending.current) return;
    messageSending.current = true;
    setIsMessageInputOK(false);

    // LOGICAでの投稿
    const trimmedMessage = chatMessageInput.trim();
    chatPostMessageMutation({
      variables: {
        message: trimmedMessage
      },
      onCompleted: _ref7 => {
        let {
          postChatMessage
        } = _ref7;
        if (postChatMessage !== null && postChatMessage !== void 0 && postChatMessage.isNGMessage) {
          setIsPostedNGMessage(true);
        } else {
          setChatMessageInput("");
          setIsPostedNGMessage(false);
          chatMessageModifier(chatMessages => {
            var _postChatMessage$send;
            return [...takeRight(chatMessages, appMessageLimit - 1), {
              id: postChatMessage.id,
              displayName: (_postChatMessage$send = postChatMessage.sender) === null || _postChatMessage$send === void 0 ? void 0 : _postChatMessage$send.displayName,
              userId: postChatMessage.sender.id,
              postDesc: postChatMessage.message
            }];
          });
          jumpButtonClickHandler();
          sendCommentEvent(chatRoomInfo.id, user === null || user === void 0 ? void 0 : user.hashedUserId);
        }
        messageSending.current = false;
        setIsMessageInputOK(true);
      },
      onError: e => {
        messageSending.current = false;
      }
    });
  }, [chatMessageInput, nickName, appMessageLimit, jumpButtonClickHandler, chatMessageModifier, chatRoomInfo, user]);

  // チャットメッセージキューを処理
  const chatIntervalId = useRef(null);
  const chatIntervalProcess = useCallback(() => {
    if (!isViewingPastMessage) {
      const message = chatMessageDeQueue();
      if (message != undefined && message != null) {
        if (chatMessageFilter(message)) {
          chatMessageModifier(chatMessages => {
            var _message$sender;
            return [...takeRight(chatMessages, appMessageLimit - 1), {
              id: message.id,
              displayName: (_message$sender = message.sender) === null || _message$sender === void 0 ? void 0 : _message$sender.displayName,
              userId: message.sender.id,
              postDesc: message.message
            }];
          });
          setChatIntervalRandom();
        }
      }
    }
  }, [appMessageLimit, isViewingPastMessage, setChatIntervalRandom, chatMessageFilter, chatMessageDeQueue, chatMessageModifier]);
  useEffect(() => {
    clearTimeout(chatIntervalId.current);
    if (chatDisplay) {
      chatIntervalId.current = setInterval(chatIntervalProcess, chatInterval);
    }
    return () => {
      clearTimeout(chatIntervalId.current);
    };
  }, [chatDisplay, chatInterval, chatIntervalProcess]);
  useEffect(() => {
    setChatIntervalRandom();
  }, [chatIntervalStandard, setChatIntervalRandom]);
  const toggleDisplayEmojipicker = useCallback(() => {
    if (nickName) {
      setDisplayEmojiPicker(!displayEmojiPicker);
    }
  }, [nickName, displayEmojiPicker]);
  const handleEmojiPick = useCallback(e => {
    var _chatInputRef$current3, _chatInputRef$current4;
    //setChatMessageInput(chatMessageInput + e.native);
    let value = (_chatInputRef$current3 = chatInputRef.current) === null || _chatInputRef$current3 === void 0 ? void 0 : _chatInputRef$current3.value;
    let pos = (_chatInputRef$current4 = chatInputRef.current) === null || _chatInputRef$current4 === void 0 ? void 0 : _chatInputRef$current4.selectionStart;
    value = value.split("");
    value.splice(pos, 0, e.native);
    value = value.join("");
    chatInputRef.current.value = value;
    setChatMessageInput(value);
    chatInputRef.current.setSelectionRange(pos + e.native.length, pos + e.native.length);
    chatInputRef.current.focus();
    setDisplayEmojiPicker(false);
  }, []);

  // メッセージ削除ダイアログ表示
  const modalOnClose = useCallback(() => {
    watchPartyRef.current.start();
    setIsMessageControlling(false);
  }, []);
  const modalCloseHandle = useCallback(() => {
    hideModal();
    modalOnClose();
  }, [hideModal, modalOnClose]);
  const displayChatMessageDeleteModal = useCallback(props => {
    setIsMessageControlling(true);
    watchPartyRef.current.pause();
    showModal( /*#__PURE__*/_jsx(ChatMessageDeleteModal, _objectSpread({
      handleClick: handleChatMessageDeleteClick,
      modalCloseHandle: modalCloseHandle // モーダルコンポーネントの閉じるボタンを利用しないので、別途CLOSEボタン用の関数を渡す
    }, props)), {
      closeButton: false,
      outerAreaClose: false,
      style: "chatMessageDeleteModal",
      onClose: modalOnClose
    });
  }, [showModal, modalCloseHandle, handleChatMessageDeleteClick, modalOnClose]);

  // メッセージ非表示/通報ダイアログ表示
  const displayChatMessageReportModal = useCallback(props => {
    setIsMessageControlling(true);
    watchPartyRef.current.pause();
    showModal( /*#__PURE__*/_jsx(ChatMessageReportModal, _objectSpread(_objectSpread({
      modalCloseHandle: modalCloseHandle // モーダルコンポーネントの閉じるボタンを利用しないので、別途CLOSEボタン用の関数を渡す
      ,
      roomId: chatRoomInfo.id
    }, props), {}, {
      addMutedMessage: addMutedMessage,
      addMutedUser: addMutedUser,
      handleReportComplete: handleReportComplete,
      reportComplete: reportComplete,
      reportedMessageIds: reportedMessageIds
    })), {
      closeButton: false,
      outerAreaClose: false,
      style: "chatMessageReportModal",
      onClose: modalOnClose
    });
  }, [showModal, chatRoomInfo, reportedMessageIds, handleReportComplete, reportComplete, modalCloseHandle, modalOnClose, addMutedMessage, addMutedUser]);
  const windowReload = useCallback(() => {
    window.location.reload();
  }, []);

  // ルーム情報定期更新
  const fetchroom = useCallback(() => {
    const params = {
      from: lastRoomUpdatedCheckTimeStamp,
      limit: roomUpdateMessageLimit !== null && roomUpdateMessageLimit !== void 0 ? roomUpdateMessageLimit : 100,
      types: "roomUpdated"
    };
    const query = Object.keys(params).map(key => key + "=" + encodeURIComponent(params[key])).join("&");
    const url = `https://${config.chat.endpoint}/v1/projects/${config.chat.projectId}/rooms/${chatRoomInfo.id}/messages?${query}`;
    try {
      fetch(url, {
        method: "get",
        headers: {
          Authorization: `Bearer ${chatRoomInfo.token}`
        },
        cache: "no-store"
      }).then(response => response.json()).then(res => {
        const latestMessage = res.messages.filter(message => message.type == "roomUpdated").sort((a, b) => {
          return b.data.sentAt - a.data.sentAt;
        })[0];
        if (latestMessage) {
          var _latestMessage$data, _latestMessage$data2;
          const latest = latestMessage === null || latestMessage === void 0 || (_latestMessage$data = latestMessage.data) === null || _latestMessage$data === void 0 ? void 0 : _latestMessage$data.sentAt;
          const updateParam = latest && latest > lastRoomUpdatedCheckTimeStamp ? latest : lastRoomUpdatedCheckTimeStamp;
          setLastRoomUpdatedCheckTimeStamp(updateParam + 1);
          if (latestMessage !== null && latestMessage !== void 0 && (_latestMessage$data2 = latestMessage.data) !== null && _latestMessage$data2 !== void 0 && (_latestMessage$data2 = _latestMessage$data2.room) !== null && _latestMessage$data2 !== void 0 && (_latestMessage$data2 = _latestMessage$data2.customData) !== null && _latestMessage$data2 !== void 0 && _latestMessage$data2.chatEndDateTime && !dayjs(chatRoomInfo.chatEndDateTime).isSame(dayjs(latestMessage.data.room.customData.chatEndDateTime))) {
            setChatRoomInfo(_objectSpread(_objectSpread({}, chatRoomInfo), {}, {
              chatEndDateTime: String(latestMessage.data.room.customData.chatEndDateTime)
            }));
          }
        } else {
          setLastRoomUpdatedCheckTimeStamp(lastRoomUpdatedCheckTimeStamp + 1);
        }
      });
    } catch (e) {
      console.log("fetch error");
    }
  }, [chatRoomInfo, lastRoomUpdatedCheckTimeStamp, roomUpdateMessageLimit]);
  useEffect(() => {
    if (watchPartyRef.current && chatJoined) {
      if (roomUpdateIntervalId.current) {
        clearInterval(roomUpdateIntervalId.current);
      }
      roomUpdateIntervalId.current = setInterval(fetchroom, roomUpdateIntervalMinute);
    }
    return () => {
      clearInterval(roomUpdateIntervalId.current);
    };
  }, [chatJoined, chatRoomInfo, roomUpdateIntervalMinute, lastRoomUpdatedCheckTimeStamp]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [chatDisplay && !isChatError && !agreementDataLoading && /*#__PURE__*/_jsxs("div", {
      className: Styles.container,
      children: [/*#__PURE__*/_jsxs("div", {
        className: Styles.chatHeader,
        children: [/*#__PURE__*/_jsx("p", {
          children: "\u30C1\u30E3\u30C3\u30C8"
        }), /*#__PURE__*/_jsx(Button, {
          chatCloseX: true,
          onClick: hideChat,
          children: "\xD7"
        })]
      }), /*#__PURE__*/_jsx("hr", {
        style: {
          width: "100%",
          borderColor: "#101010"
        }
      }), displayChatEndNotification == "nearlyEnd" && isWarningVisible && /*#__PURE__*/_jsx("div", {
        className: Styles.popupNotification,
        children: /*#__PURE__*/_jsxs("p", {
          children: ["\u307E\u3082\u306A\u304F\u30C1\u30E3\u30C3\u30C8\u304C\u7D42\u4E86\u3057\u307E\u3059\u3002", /*#__PURE__*/_jsx("br", {}), "\u30C1\u30E3\u30C3\u30C8\u6A5F\u80FD\u306E\u5229\u7528\u306F", dayjs(chatEndTime).format("HH:mm"), "\u307E\u3067\u3067\u3059\u3002"]
        })
      }), displayChatEndNotification == "ended" && /*#__PURE__*/_jsx("div", {
        className: Styles.popupNotification,
        style: {
          top: "50%"
        },
        children: /*#__PURE__*/_jsxs("p", {
          children: ["\u30C1\u30E3\u30C3\u30C8\u6B04\u3092\u7D42\u4E86\u3057\u307E\u3057\u305F\u3002", /*#__PURE__*/_jsx("br", {}), "\u3054\u5229\u7528\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3057\u305F\uFF01"]
        })
      }), displayChatEndNotification !== "ended" && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          className: Styles.chatDisplay,
          onScroll: handleChatMessageAreaScroll,
          ref: chatMessageAreaRef,
          children: /*#__PURE__*/_jsx("div", {
            className: Styles.chatDisplayAlignBottom,
            children: chatMessages.map(item => /*#__PURE__*/_jsx("div", {
              className: Styles.chatMessageDisplay,
              "data-id": item.id,
              onClick: handleChatMessageClick,
              children: /*#__PURE__*/_jsxs("div", {
                className: Styles.chatMessage,
                children: [/*#__PURE__*/_jsx("span", {
                  className: Styles.username,
                  children: item.displayName
                }), /*#__PURE__*/_jsx("span", {
                  className: Styles.messageContent,
                  children: item.postDesc
                })]
              })
            }, item.id))
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: Styles.footer,
          children: [/*#__PURE__*/_jsx("div", {
            className: Styles.chatScrollToRecentBtnArea,
            children: isViewingPastMessage && /*#__PURE__*/_jsx(Button, {
              className: Styles.chatScrollToRecentBtn,
              onClick: jumpButtonClickHandler,
              children: /*#__PURE__*/_jsx(ChatNewMessageIcon, {})
            })
          }), /*#__PURE__*/_jsxs("div", {
            className: Styles.chatInputContainer,
            children: [isPostedNGMessage && /*#__PURE__*/_jsx("div", {
              className: Styles.isPostedNGMessage,
              children: /*#__PURE__*/_jsx("div", {
                className: Styles.isPostedNGMessageContent,
                children: /*#__PURE__*/_jsxs("p", {
                  children: ["\u4E0D\u9069\u5207\u306A\u8868\u73FE\u304C\u542B\u307E\u308C\u3066\u3044\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002", /*#__PURE__*/_jsx("br", {}), "\u898B\u76F4\u3057\u3066\u6539\u3081\u3066\u6295\u7A3F\u3057\u3066\u304F\u3060\u3055\u3044\u3002"]
                })
              })
            }), /*#__PURE__*/_jsxs("div", {
              className: Styles.chatInputSubContainer,
              children: [/*#__PURE__*/_jsxs("div", {
                className: classnames(Styles.chatInputUIContainar, {
                  [Styles.isPostedNGMessage]: isPostedNGMessage || isChatInputOver
                }),
                onClick: displayNickNameInputModal,
                children: [/*#__PURE__*/_jsx("input", {
                  className: Styles.chatInput,
                  ref: chatInputRef,
                  placeholder: "\u30C1\u30E3\u30C3\u30C8\u3092\u5165\u529B...",
                  value: chatMessageInput,
                  onChange: handleChatMessageInputChange,
                  onKeyDown: handleChatMessageOnKeyDown,
                  onCompositionStart: turnOnIsComposing,
                  onCompositionEnd: turnOffIsComposing,
                  disabled: (messageSending === null || messageSending === void 0 ? void 0 : messageSending.current) && isMessageInputOK
                }), /*#__PURE__*/_jsx("button", {
                  onClick: toggleDisplayEmojipicker,
                  disabled: messageSending === null || messageSending === void 0 ? void 0 : messageSending.current,
                  children: /*#__PURE__*/_jsx(EmojiIcon, {
                    className: classnames("", {
                      [Styles.displayEmojiPicker]: displayEmojiPicker
                    })
                  })
                }), displayEmojiPicker && /*#__PURE__*/_jsx(Picker, {
                  onEmojiSelect: handleEmojiPick,
                  i18n: i18n,
                  theme: "dark",
                  searchPosition: "none",
                  previewPosition: "none",
                  skinTonePosition: "none",
                  navPosition: "none",
                  dynamicWidth: true,
                  maxFrequentRows: 1,
                  emojiSize: 16,
                  native: true
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: Styles.chatInputSendContainar,
                children: [/*#__PURE__*/_jsxs("div", {
                  className: Styles.inputCount,
                  children: [chatMessageInput.length > 0 && !isChatSendOK && /*#__PURE__*/_jsx("p", {
                    className: Styles.countAlert,
                    children: chatMessageLimit - count
                  }, "chatInputCount"), isChatSendOK && /*#__PURE__*/_jsx("p", {
                    className: Styles.countOk,
                    children: chatMessageLimit - count
                  }, "chatInputCount")]
                }), /*#__PURE__*/_jsx(Button, {
                  fillMainColor: true,
                  borderStyle: true,
                  chatSend: true,
                  onClick: nickName ? handlePost : displayNickNameInputModal,
                  disabled: !isChatSendOK || (messageSending === null || messageSending === void 0 ? void 0 : messageSending.current),
                  children: /*#__PURE__*/_jsx(ChatPostIcon, {})
                })]
              })]
            })]
          })]
        })]
      })]
    }), chatDisplay && isChatError && /*#__PURE__*/_jsxs("div", {
      className: Styles.container,
      children: [/*#__PURE__*/_jsxs("div", {
        className: Styles.chatHeader,
        children: [/*#__PURE__*/_jsx("p", {
          children: "\u30C1\u30E3\u30C3\u30C8"
        }), /*#__PURE__*/_jsx(Button, {
          chatCloseX: true,
          onClick: hideChat,
          children: "\xD7"
        })]
      }), /*#__PURE__*/_jsx("hr", {
        style: {
          width: "100%",
          borderColor: "#101010"
        }
      }), /*#__PURE__*/_jsx("div", {
        className: Styles.chatDisplay,
        children: /*#__PURE__*/_jsxs("div", {
          className: Styles.chatMessage,
          children: [/*#__PURE__*/_jsx("span", {
            className: Styles.messageContent,
            children: "\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002"
          }), /*#__PURE__*/_jsx(Button, {
            fillColor: true,
            medium: true,
            onClick: windowReload,
            children: "\u518D\u8AAD\u307F\u8FBC\u307F\u3059\u308B"
          })]
        })
      })]
    })]
  });
};
export default ChatDisplay;